import React, { useMemo } from 'react'
import {
    Chart as ChartJS,
    LineElement,
    Tooltip,
    CategoryScale,
    LinearScale,
    PointElement,
    Filler,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import { COLORS, getBorderWidth, getPointBorderWidth, getPointRadius, options } from './config'
import styles from './styles.module.scss'

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Filler)

export const StatsJoueurChart = ({ data }: { data: number[] }) => {
    const points = data.length
    const labels = useMemo(() => Array.from({ length: points }, (_, i) => i + 1), [points])

    return (
        <div className={styles.container}>
            <Line
                data={{
                    labels,
                    datasets: [
                        {
                            label: '',
                            borderColor: COLORS.blue,
                            borderWidth: getBorderWidth(points),
                            pointBorderColor: COLORS.blue,
                            pointBackgroundColor: COLORS.blue10,
                            pointHoverBorderColor: COLORS.red,
                            pointHoverBackgroundColor: COLORS.blue10,
                            animation: false,

                            pointBorderWidth: getPointBorderWidth(points),
                            pointHoverBorderWidth: getPointBorderWidth(points),
                            pointRadius: getPointRadius(points),
                            pointHoverRadius: getPointRadius(points),
                            fill: true,
                            backgroundColor: ({ chart: { ctx } }) => {
                                const gradientFill = ctx.createLinearGradient(0, 0, 0, 100)
                                gradientFill.addColorStop(0, 'rgba(5,9,113,0.9)')
                                gradientFill.addColorStop(0.2, 'rgba(5,9,113,0.7)')
                                gradientFill.addColorStop(1, 'rgba(255,255,255,0)')
                                return gradientFill
                            },
                            data,
                        },
                    ],
                }}
                options={options}
            />
        </div>
    )
}
